"use strict";
/* tslint:disable */
var TResponsiveLineType = Object.assign({}, TBaseLineType, {
    buildView: function (selection, mode, context) {
        if (Selections.isHidden(selection)) {
            return '';
        }
        // adds "same_event" and "show_odds_msg" classes - Monov
        var wrapperClasses = Selections.getWrapperClasses(mode, selection);
        var selectionType = BetSlipUtil.getSelectionType(selection);
        var __html = '';
        if (mode.isFirstSelection) {
            __html += mode.buildHeader();
        }
        __html += `
            <div id="sce_${selection.ViewKey}" class="betSlip-bets-item ${wrapperClasses} ${selectionType}" data-uat="bet-selection">
                ${this.buildInnerView(selection, mode, context, selectionType)}
            </div>
        `;
        mode.isFirstSelection = false;
        return __html;
    },
    buildInnerView: function (selection, mode, context, selectionType) {
        var lineType = BetSlipUtil.getLineType();
        var selectionType = selectionType || BetSlipUtil.getSelectionType(selection);
        var __html = '';
        __html += `
			<div class="betSlip-row-wrapper ${lineType}" data-gesture="pan" data-uat="bet-slip-row-wrapper">
                ${this.buildRowWrapperContent(selection, mode, context, lineType, selectionType)}
            </div>
            ${TSlipShared.createInlineMessage(mode, selection, context)}`;
        if (!TSlipShared.shouldHideInlineMessage(mode, selection, context) && Selections.isValidBetInProcess(mode, selection)) {
            __html += TSlipShared.createBonusBettingMessage(mode);
        }
        return __html;
    },
    defaultLine: function (selection, selectionType, mode, context) {
        var hideCheckbox = BetSlipUtil.hideSelectionCheckbox(selection, mode) ? "hide-checkbox" : "";
        var hideBuyPointsSelect = BetSlipUtil.hideBuyPointsSelect(mode) ? "hide-select" : "";
        var combiRowStake = Modes.isCombinatorMode(mode) ? "combi-row-stake" : "";
        var shouldShowOdds = !Modes.isTeaserMode(mode);
        var __html = '';
        __html += `
            <div class="betSlip-head-row ${hideCheckbox}">
                <div class="betSlip-checkbox betSlip-checkbox--multiSelection" data-uat="selection-in-use">
                    ${TSlipShared.createMultiSelectionBox(mode, selection)}
                </div>
                <div class="betSlip-bet-coef" data-uat="bet-slip-bet-coef">
                    ${TSelections[selectionType].buildPick(mode, selection, context)}`;
        if (shouldShowOdds) {
            __html += TSlipShared.createPickLineOdds(mode, selection, context);
        }
        __html += `
                </div>
            </div>
            <div class="betSlip-buy-points ${hideBuyPointsSelect}">
                ${TSlipShared.createBuyPointsSelect(selection)}
            </div>
            <div class="betSlip-row-content">
                <div class="betSlip-bet-desc">
                    <div class="betSlip-row-desc" data-uat="bet-slip-row-desc">
                        ${TSelections[selectionType].buildDescription(mode, selection, context)}
                        <div class="betSlip-checkbox">
                            ${this.createEachwayBox.defaultLine(selection, mode, context)}
                        </div>
                    </div>
                </div>
            </div>
            <div class="betSlip-row-stake ${combiRowStake}">
                <div class="stake-options">
                    <div class="betSlip-stake">
                        ${this.buildToReturnValue(mode, selection)}
                        ${TSlipShared.createSingleStakeBox(mode, selection)}
                        <div class="betSlip-row-desc" data-uat="bet-slip-row-desc">
                            ${TMinMax.createMinMaxForSingleSlipMode(mode, selection)}
                        </div>
                    </div>
                    ${TSlipShared.createMaxBet(selection, mode)}
                    ${TSlipShared.createCombinatorGroupSelect(mode, selection)}
                </div>
            </div>`;
        return __html;
    },
    UKLine: function (selection, selectionType, mode, context) {
        var hideCheckbox = BetSlipUtil.hideSelectionCheckbox(selection, mode) ? "hide-checkbox" : "";
        var shouldShowOdds = !Modes.isTeaserMode(mode);
        var __html = '';
        __html += `
            <div class="betSlip-head-row ${hideCheckbox}">
                <div class="betSlip-checkbox betSlip-checkbox--multiSelection" data-uat="selection-in-use">
                    ${TSlipShared.createMultiSelectionBox(mode, selection)}
                </div>
                <div class="betSlip-bet-coef" data-uat="bet-slip-bet-coef">
                    ${TSelections[selectionType].buildPick(mode, selection, context)}`;
        if (shouldShowOdds) {
            __html += TSlipShared.createPickLineOdds(mode, selection, context);
        }
        __html += `
                </div>
            </div>
            <div class="betSlip-row-content">
                <div class="betSlip-bet-desc">
                    <div class="betSlip-row-desc" data-uat="bet-slip-row-desc">
                        ${TSelections[selectionType].buildDescription(mode, selection, context)}
                    </div>
                </div>
            </div>
            ${this.UKLineStakeBox(selection, mode, context)}`;
        return __html;
    },
    UKLineStakeBox: function (selection, mode, context) {
        var __html = `
                <div class="betSlip-buy-points">
                    ${TSlipShared.createBuyPointsSelect(selection)}
                </div>
                ${this.createRowStake(selection, mode, context)}
            `;
        return __html;
    },
    createRowStake: function (selection, mode, context) {
        return `
            <div class="betSlip-row-stake">
                <div class="stake-options">
                    <div class="betSlip-checkbox">
                        ${this.createEachwayBox.UKLine(selection, mode, context)}
                    </div>
                    <div class="betSlip-stake">
                        ${this.buildToReturnValue(mode, selection)}
                        ${TSlipShared.createSingleStakeBox(mode, selection)}
                        <div class="betSlip-row-desc" data-uat="bet-slip-row-desc">
                            ${TMinMax.createMinMaxForSingleSlipMode(mode, selection)}
                        </div>
                    </div>
                    ${TSlipShared.createUKMaxBet(selection, mode)}
                </div>
            </div>
        `;
    },
    editModeLine: function (selection, selectionType, mode, context) {
        return `
            <div class="betSlip-row-content edit-mybets-line">
                <span class="edit-mybets-message">
                    ${selection.BetID ? $dict.bs("ExistingSelection") : $dict.bs("NewSelection")}
                </span>
                <div class="betSlip-edit-mybets-selection">
                    ${TSelections[selectionType].buildPick(mode, selection, context)}
                    ${TSlipShared.createPickLineOdds(mode, selection, context)}
                </div>
                <div>
                    <div class="betSlip-row-desc" data-uat="bet-slip-row-desc">
                        ${TSelections[selectionType].buildDescription(mode, selection, context)}
                    </div>
                </div>
            </div>
        `;
    },
    buildToReturnValue: function (mode, selection) {
        if (BetSlipUtil.showNAForRelatedSelections() || !Selections.displaySingleToReturnValue(mode)) {
            return '';
        }
        var toReturnValue = mode.getSingleReturn(selection.ViewKey) || '';
        return `
            <div class="betSlip-stake-return returnBox">
                <span class="betSlip-stake-return-head">${$string("BettingHistory").Return}</span>
                <span class="betSlip-stake-return-value" id="single_return_value_${selection.ViewKey}" data-uat="bet-slip-total-return-value">${toReturnValue}</span>
            </div>
        `;
    }
});
window.TResponsiveLineType = TResponsiveLineType;
//# sourceMappingURL=TResponsiveLineType.js.map